export const NOT_FOUND_CODE = 404;
export const ERR_NETWORK = 'ERR_NETWORK';
